import React from 'react';

import classNames from 'classnames';

import { Chevron as ChevronIcon, ChevronVariant } from '../Chevron/Chevron';
import styles from './ChevronInACircle.module.css';

export type Props = {
  circleSize?: number;
  circleThickness?: number;
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  transitionDuration?: number;
  variant?: ChevronVariant;
  width?: number;
};

export const ChevronInACircle = React.memo(
  (props: Props) => {
    const {
      color = '#0f0a1b',
      variant = 'left',
      circleSize = 16,
      circleThickness = 2,
      width = 12,
      height = 12,
      className,
      onClick,
      transitionDuration,
    } = props;

    const classes = classNames(
      styles.circle,
      className,
    );

    const style = {
      '--color': color,
      '--size': `${circleSize}px`,
      '--border-size': `${circleThickness}px`,
    } as React.CSSProperties;

    return (
      <div className={classes} style={style} onClick={onClick}>
        <ChevronIcon
          variant={variant}
          fill={color}
          width={width}
          height={height}
          transitionDuration={transitionDuration}
        />
      </div>
    );
  },
);

ChevronInACircle.displayName = 'ChevronInACircle';
